// RU-SCANPERF SP-9: a scanner name that opens that scanner's performance page (/signals/scanner/<key>).
// A real <a href> (open in new tab, long-press work on phones); a plain click navigates client-side through the
// app router (lib/navBridge) and never reaches the card / row underneath. Without a registered router the
// browser follows the href.
import { navigateTo } from "@/lib/navBridge";

export const SCANNER_NAMES = {
  trap:            "Trap Signal",
  momentum:        "Momentum",
  commodity_gap:   "Commodity Gap",
  orb:             "Range Breakout",
  vwap:            "VWAP Reversion",
  mean_reversion:  "Mean Reversion",
  breakout:        "Breakout",
  fvg_ob:          "FVG / Order Block",
  liquidity_sweep: "Liq. Sweep",
  orb_intraday:    "ORB Intraday",
};

export const isKnownScanner = (key) => Object.prototype.hasOwnProperty.call(SCANNER_NAMES, key || "");

export const scannerPath = (key) => `/signals/scanner/${encodeURIComponent(key)}`;

export const scannerName = (key) =>
  SCANNER_NAMES[key] || String(key || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export default function ScannerLink({ scanner, className = "", testid, title, children }) {
  const label = children ?? scannerName(scanner);
  if (!isKnownScanner(scanner)) return <span className={className}>{label}</span>;
  const to = scannerPath(scanner);
  function onClick(e) {
    e.stopPropagation();
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (navigateTo(to)) e.preventDefault();
  }
  return (
    <a href={to} onClick={onClick} data-testid={testid || `scanner-link-${scanner}`}
       title={title || `${scannerName(scanner)}: performance of all its signals`}
       className={`hover:underline underline-offset-2 cursor-pointer ${className}`}>
      {label}
    </a>
  );
}
